var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("CantTransactions", {
        directives: [
          {
            name: "can",
            rawName: "v-can",
            value: "Cantidad Trasacciones",
            expression: "'Cantidad Trasacciones'",
          },
        ],
        ref: "CantTransactions",
      }),
      _c("processed-docs", { ref: "ProcessedDocs" }),
      _c("pending-docs", { ref: "PendingDocs" }),
      _c("config-billing-date", { ref: "ConfigBillingDate" }),
      _c("config-trade-name", { ref: "ConfigTradeName" }),
      _c("config-contingency-auto", { ref: "ConfigContingencyAuto" }),
      _c("config-activar-dee", { ref: "ConfigActivarDEE" }),
      _c("config-address-optional", { ref: "ConfigAddressOptional" }),
      _c("config-email-optional", { ref: "ConfigEmailOptional" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }